const GA_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || '').trim();
const CURRENCY = 'BRL';

export const isAnalyticsEnabled = () => /^G-[A-Z0-9]+$/i.test(GA_ID);

let initialized = false;
export const initAnalytics = () => {
  if (initialized || !isAnalyticsEnabled() || typeof window === 'undefined') return;
  initialized = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false, anonymize_ip: true });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s);
};

const send = (event, params) => {
  if (!isAnalyticsEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', event, params);
};

const variantLabel = (i) =>
  [i.selectedPrimary, i.selectedColor, i.selectedVoltage, i.selectedSize, i.selectedDuctSize]
    .filter(Boolean).join(' / ') || undefined;

const toGaItem = (i, qty) => ({
  item_id: i.product_id || i.id,
  item_name: i.name,
  item_category: i.category || undefined,
  item_variant: variantLabel(i),
  price: Number(i.price) || 0,
  quantity: qty ?? i.quantity ?? 1,
});

const value = (items) => items.reduce((s, i) => s + (Number(i.price) || 0) * (i.quantity ?? 1), 0);

export const trackPageView = (path, title) =>
  send('page_view', { page_path: path, page_title: title, page_location: window.location.href });

export const trackViewItem = (product) =>
  send('view_item', { currency: CURRENCY, value: Number(product.price) || 0, items: [toGaItem(product, 1)] });

export const trackAddToCart = (item) =>
  send('add_to_cart', {
    currency: CURRENCY,
    value: (Number(item.price) || 0) * (item.quantity || 1),
    items: [toGaItem(item)],
  });

export const trackBeginCheckout = (items) =>
  send('begin_checkout', { currency: CURRENCY, value: value(items), items: items.map((i) => toGaItem(i)) });

const PURCHASED_KEY = 'eletrovex_ga_purchased';
export const trackPurchase = (order) => {
  if (!order?.external_reference) return;
  const done = JSON.parse(localStorage.getItem(PURCHASED_KEY) || '[]');
  if (done.includes(order.external_reference)) return;
  send('purchase', {
    transaction_id: order.external_reference,
    currency: order.currency || CURRENCY,
    value: Number(order.total_amount) || 0,
    items: (order.items || []).map((i) => toGaItem(i)),
  });
  localStorage.setItem(PURCHASED_KEY, JSON.stringify([...done, order.external_reference].slice(-20)));
};
